import { createAsyncThunk } from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';
import { pollDownloadStatus } from '@vk-hr-tek/core/download-notification/slice';
import { setDownloadWaiting } from '@vk-hr-tek/core/download-notification';

import {
  CreateEventBatchDocumentZipResponse,
  EventsService,
} from '@app/gen/events';
import { ThunkExtra } from '@app/store';

import { EventsDownloadService } from '../../services';
import { ReviewWithRootState } from '../review.state';
import { BatchDownloadStartDto } from '../../dto';

export const startDownload = createAsyncThunk<
  CreateEventBatchDocumentZipResponse,
  BatchDownloadStartDto,
  ThunkExtra<ReviewWithRootState>
>(
  'events/startBatchDownload',
  async (
    batchDownloadStartDto: BatchDownloadStartDto,
    { rejectWithValue, dispatch, extra: { inject } },
  ) => {
    try {
      const service = inject(EventsDownloadService);
      const eventService = inject(EventsService);

      const { totalCount, filters } = batchDownloadStartDto;

      let downloadId;
      if (totalCount) {
        const result = await eventService.operationEvents({
          body: {
            ...(filters && { filters }),
            operation: 'batch_download',
          },
        });

        downloadId = result.download_id || '';
      } else {
        const result = await service.startDownload(batchDownloadStartDto);

        downloadId = result.download_id;
      }

      await dispatch(
        setDownloadWaiting({
          id: downloadId,
          count: totalCount || batchDownloadStartDto.event_ids.length,
        }),
      );

      dispatch(
        pollDownloadStatus({
          download_id: downloadId,
        }),
      );

      return {
        download_id: downloadId,
      };
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);
